import * as React from "react";
import type { SVGProps } from "react";
const SvgVolumeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="volume_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M743.253 118.741 381.44 291.84H228.267a121.6 121.6 0 0 0-121.6 121.685v147.371a121.6 121.6 0 0 0 121.6 121.643h157.226L742.06 857.94c80.81 39.766 175.274-19.072 175.274-109.184V228.48c0-89.515-93.354-148.395-174.08-109.739zm-496.81 725.59-40.406-128.086c5.12.64 10.24.982 15.531.982h186.027l26.581 87.168c15.744 51.541-13.013 99.84-66.005 110.933-50.347 10.581-106.283-22.059-121.728-70.997z"
    />
  </svg>
);
export default SvgVolumeIcon;
